import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { logger } from '../utils/logger';

const AuthRedirectHandler: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      const redirectUrl = localStorage.getItem('loginRedirectUrl');
      
      if (redirectUrl) {
        localStorage.removeItem('loginRedirectUrl');
        logger.log('Redirecting to stored URL:', redirectUrl);
        navigate(redirectUrl, { replace: true });
      }
    }
  }, [isAuthenticated, navigate]);

  return null; // This component doesn't render anything
};

export default AuthRedirectHandler; 